import(/* webpackMode: "eager" */ "/codebuild/output/src4093322249/src/apps/profile/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4093322249/src/apps/profile/src/components/desktop-padding/DesktopPadding.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4093322249/src/apps/profile/src/components/dev-tools/DevTools.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DevToolsProvider","useDevTools"] */ "/codebuild/output/src4093322249/src/apps/profile/src/components/dev-tools/DevToolsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useMfeVersions"] */ "/codebuild/output/src4093322249/src/apps/profile/src/components/dev-tools/hooks/useMfeVersions.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4093322249/src/apps/profile/src/components/mfes/MFEsLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/codebuild/output/src4093322249/src/apps/profile/src/components/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4093322249/src/apps/profile/src/Providers/ToastProvider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4093322249/src/node_modules/.pnpm/@rv-life+design-system@28.0.1_@dnd-kit+core@6.3.1_react-dom@19.3.1_react@19.3.1__react@_1943faa9ffff0375b123cd61da9d76f7/node_modules/@rv-life/design-system/dist/src/design-system.css");
